var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-sm-12"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.date))]),_c('h6',{staticClass:"card-subtitle mb-2 text-muted"},[_vm._v("KW "+_vm._s(_vm.cw))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }